/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateQuestionAnswerRequest,
  TCreateQuestionAnswerModel,
  IMappers,
  TCreateQuestionAnswerResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IEntityCreatedResponse } from '../../entities/common/EntityCreatedResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateQuestionAnswerModel(parameters: TCreateQuestionAnswerRequest): TCreateQuestionAnswerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/create-question-answer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateQuestionAnswerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateQuestionAnswerRequest;
}

export async function fetchCreateQuestionAnswer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateQuestionAnswerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateQuestionAnswerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateQuestionAnswerModel(parameters),
    config,
  )) as FetchResponse<TCreateQuestionAnswerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEntityCreatedResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateQuestionAnswerResponse>;
}
